import React from "react";
import { StarIcon } from "lucide-react";
import { Reveal } from "../ui/Reveal";
import { SectionTitle } from "../ui/SectionTitle";
import { FacebookPost } from "../facebook/FacebookPost";
import { desserts } from "../../data/images";
export function SocialProofSection() {
  return <section className="relative overflow-hidden bg-white py-20 lg:py-28" data-id="element-417" data-mp="24bdyk9m42b2s">
      <div className="mx-auto max-w-6xl px-5" data-id="element-418" data-mp="249ax8tficvir">
        <SectionTitle intro="Esto es lo que comentaron en uno de nuestros videos. Sin filtros." data-id="element-419" data-mp="1qatdf6sq4364">
          Lo Que Están Diciendo las Primeras Usuarias
        </SectionTitle>
        <Reveal className="mx-auto mt-5 flex w-fit items-center gap-2 text-sm font-semibold text-cocoa-light" data-id="element-420" data-mp="1gdyh8ujxaev0">
          <span className="flex gap-0.5" data-id="element-421" data-mp="1lbzz5c5m484w">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" data-id="element-422" data-mp="3arg7ipbppptq" data-mpi={i} />)}
          </span>
          4.9 de 5 · +2,000 mujeres
        </Reveal>

        <div className="relative mt-12" data-id="element-423" data-mp="3foq2ekhvetoy">
          <img src={desserts.blueberryCheesecakes} alt="" aria-hidden className="absolute -left-4 top-24 hidden w-52 -rotate-6 rounded-2xl border-8 border-white object-cover shadow-xl xl:block" data-id="element-424" data-mp="neepmxni8n3m" />
          <img src={desserts.hazelnutCups} alt="" aria-hidden className="absolute -right-4 top-[40%] hidden w-52 rotate-6 rounded-2xl border-8 border-white object-cover shadow-xl xl:block" data-id="element-425" data-mp="w9m9pvnfod28" />
          <Reveal data-id="element-426" data-mp="3vnez7vd4jyq2">
            <FacebookPost data-id="element-427" data-mp="3vnyd90znm2yt" />
          </Reveal>
        </div>
      </div>
    </section>;
}